/**
 * @description 用户模块
 */
export default [
    {
        path: "/user/self", //地址
        name: "user_self",
        component: () => import("@/views/user/self/Self.vue"),
        meta: {
            title: "个人中心-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/setting", //设置
        name: "user_setting",
        component: () => import("@/views/user/self/Setting.vue"),
        meta: {
            title: "设置-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/coupon", //优惠券
        name: "user_coupon",
        component: () => import("@/views/user/coupon/Coupon.vue"),
        meta: {
            title: "油柑网-优惠券",
            requiresAuth: true,
        },
    },
    {
        path: "/user/linkman", // 下单联系人
        name: "user_linkman",
        component: () => import("@/views/user/address/Linkman.vue"),
        meta: {
            title: "下单联系人-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/linkman/edit", //编辑联系人
        name: "user_linkman_edit",
        component: () => import("@/views/user/address/LinkmanEdit.vue"),
        meta: {
            title: "新建联系人-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/invoice/info", // 开票资料
        name: "user_invoice_info",
        component: () => import("../../views/user/invoice/Info.vue"),
        meta: {
            title: "开票资料-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/invoice/infoEdit", // 编辑资料
        name: "user_invoice_infoEdit",
        component: () => import("../../views/user/invoice/InfoEdit.vue"),
        meta: {
            title: "编辑资料-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/address", // 收货地址
        name: "user_address",
        component: () => import("../../views/user/address/Address.vue"),
        meta: {
            title: "收货地址-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/address/logistics", // 编辑物流地址
        name: "user_address_logistics",
        component: () =>
            import("../../views/user/address/AddressLogistics.vue"),
        meta: {
            title: "编辑物流地址-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/address/doorstep", // 编辑送货上门地址
        name: "user_address_doorstep",
        component: () => import("../../views/user/address/AddressDoorstep.vue"),
        meta: {
            title: "编辑送货上门地址-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/order/list", // 订单列表
        name: "user_order_list",
        component: () => import("../../views/user/order/OrderList.vue"),
        meta: {
            title: "订单-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/order/detail", // 订单详情
        name: "user_order_detail",
        component: () => import("../../views/user/order/OrderDetail.vue"),
        meta: {
            title: "订单详情-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/returns/list", // 退货列表
        name: "user_returns_list",
        component: () => import("../../views/user/returns/ReturnsList.vue"),
        meta: {
            title: "退货售后-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/refund/detail", // 退款详情
        name: "user_refund_detail",
        component: () => import("../../views/user/returns/RefundDetail.vue"),
        meta: {
            title: "退款详情-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/returns/detail", // 退货详情
        name: "user_returns_detail",
        component: () => import("../../views/user/returns/ReturnsDetail.vue"),
        meta: {
            title: "退货详情-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/apply/refund", // 申请退款
        name: "user_apply_refund",
        component: () => import("../../views/user/returns/ApplyRefund.vue"),
        meta: {
            title: "申请退款-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/apply/returns", // 申请退货
        name: "user_apply_returns",
        component: () => import("../../views/user/returns/ApplyReturns.vue"),
        meta: {
            title: "申请退货-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/user/qrcode", // 申请退货
        name: "user_qrcode",
        component: () => import("../../views/user/qrcode/Code.vue"),
        meta: {
            title: "我的二维码",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet", // 用户钱包
        name: "user_wallet",
        component: () => import("../../views/user/wallet/Wallet.vue"),
        meta: {
            title: "我的预付货款",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/apply", // 用户钱包 预付货款申请
        name: "user_wallet_apply",
        component: () => import("../../views/user/wallet/Apply.vue"),
        meta: {
            title: "预付货款申请",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/recharge", // 用户钱包 预付货款充值
        name: "user_wallet_recharge",
        component: () => import("../../views/user/wallet/Recharge.vue"),
        meta: {
            title: "预付货款充值",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/refund", // 用户钱包
        name: "user_wallet_refund",
        component: () => import("../../views/user/wallet/Refund.vue"),
        meta: {
            title: "退回货款",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/password", // 用户钱包 修改预付款密码
        name: "user_wallet_password",
        component: () => import("../../views/user/wallet/Password.vue"),
        meta: {
            title: "修改预付款密码",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/credit", // 用户钱包 修改预付款限额
        name: "user_wallet_credit",
        component: () => import("../../views/user/wallet/Credit.vue"),
        meta: {
            title: "修改预付款限额",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/company", // 用户钱包 修改预付款公司
        name: "user_wallet_company",
        component: () => import("../../views/user/wallet/Company.vue"),
        meta: {
            title: "修改预付款公司",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/transactionList", // 用户钱包 交易记录
        name: "user_wallet_transactionList",
        component: () => import("../../views/user/wallet/Transaction_List.vue"),
        meta: {
            title: "预付款交易记录",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/rechargeList", // 用户钱包 交易记录
        name: "user_wallet_rechargeList",
        component: () => import("../../views/user/wallet/Recharge_List.vue"),
        meta: {
            title: "预付款充值记录",
            requiresAuth: true,
        },
    },
    {
        path: "/user/wallet/agreement", // 用户钱包协议
        name: "user_wallet_agreement",
        component: () => import("../../views/user/wallet/Agreement.vue"),
        meta: {
            title: "预付货款协议",
            requiresAuth: true,
        },
    },
];
